import React, { useState } from "react";
import { LeagueContext } from "./LeagueContext";

const LeagueContextProvider = ({ children }) => {
  const [leagueCode, setLeagueCode] = useState("");
  const [sponsorChecked, setSponsorChecked] = useState(false);
  const [
    triggerClassicPublicLeagueRefetch,
    setTriggerClassicPublicLeagueRefetch,
  ] = useState(false);
  const [isLeagueMarketingPage, setIsLeagueMarketingPage] = useState(false);
  // const [leagueInfoSuccessData, setLeagueInfoSuccessData] = useState({});

  const value = {
    leagueCode,
    sponsorChecked,
    triggerClassicPublicLeagueRefetch,
    isLeagueMarketingPage,
    // leagueInfoSuccessData,
    updateLeagueCode: (value) => setLeagueCode(value),
    updateSponsorChecked: (value) => setSponsorChecked(value),
    updateTriggerClassicPublicLeagueRefetch: (value) =>
      setTriggerClassicPublicLeagueRefetch(value),
    updateIsLeagueMarketingPage: (value) => setIsLeagueMarketingPage(value),
    // updateLeagueInfoSuccessData: (value) => setLeagueInfoSuccessData(value),
  };

  return (
    <LeagueContext.Provider value={value}>{children}</LeagueContext.Provider>
  );
};

export default LeagueContextProvider;
